import api from '../api/client'

const recibosService = {
  async list(organizadorId, leilaoId = null, { dataInicio, dataFim, tipo, ordenar } = {}) {
    const qs = new URLSearchParams()
    if (leilaoId) qs.set('leilao_id', leilaoId)
    if (dataInicio) qs.set('data_inicio', dataInicio)
    if (dataFim) qs.set('data_fim', dataFim)
    if (tipo) qs.set('tipo', tipo)
    if (ordenar) qs.set('ordenar', ordenar)
    const res = await api.get(`/organizadores/${organizadorId}/recibos?${qs}`)
    return res.data
  },

  async create(organizadorId, data) {
    const res = await api.post(`/organizadores/${organizadorId}/recibos`, data)
    return res.data
  },

  async update(organizadorId, reciboId, data) {
    const res = await api.put(`/organizadores/${organizadorId}/recibos/${reciboId}`, data)
    return res.data
  },

  async delete(organizadorId, reciboId) {
    const res = await api.delete(`/organizadores/${organizadorId}/recibos/${reciboId}`)
    return res.data
  },

  async getPdf(organizadorId, reciboId) {
    const resp = await api.get(
      `/organizadores/${organizadorId}/recibos/${reciboId}/pdf`,
      { responseType: 'blob', timeout: 30000 }
    )
    return resp.data
  },

  // Recibo de comissão do mapa comprador
  async getReciboComissaoComprador(organizadorId, leilaoId, compradorId) {
    const resp = await api.get(
      `/organizadores/${organizadorId}/recibos/mapa-comprador/${leilaoId}/${compradorId}/recibo-comissao`,
      { responseType: 'blob', timeout: 30000 }
    )
    return resp.data
  },

  // Recibo de repasse para vendedor (do mapa comprador)
  async getReciboRepasseVendedor(organizadorId, leilaoId, compradorId, vendedorId) {
    const resp = await api.get(
      `/organizadores/${organizadorId}/recibos/mapa-comprador/${leilaoId}/${compradorId}/recibo-repasse/${vendedorId}`,
      { responseType: 'blob', timeout: 30000 }
    )
    return resp.data
  },

  // Recibo de pagamento do mapa vendedor
  async getReciboPagamentoVendedor(organizadorId, leilaoId, vendedorId) {
    const resp = await api.get(
      `/organizadores/${organizadorId}/recibos/mapa-vendedor/${leilaoId}/${vendedorId}/recibo-pagamento`,
      { responseType: 'blob', timeout: 30000 }
    )
    return resp.data
  },

  // Relação de recibos (PDF listagem)
  async getRelacaoPdf(organizadorId, leilaoId = null, ordenar = null) {
    const qs = new URLSearchParams()
    if (leilaoId) qs.set('leilao_id', leilaoId)
    if (ordenar) qs.set('ordenar', ordenar)
    const resp = await api.get(
      `/organizadores/${organizadorId}/recibos/relacao-pdf?${qs}`,
      { responseType: 'blob', timeout: 30000 }
    )
    return resp.data
  },
}

export default recibosService

